<template>
  <div class="projectDataV">
    <dv-loading v-if="loadingShow">Loading...</dv-loading>
    <div v-else>
      <!-- header -->
      <div class="top">{{ projectDataV.ProjectName }}</div>
      <el-row class="content">
        <!-- left -->
        <el-col :span="6">
          <dv-border-box-12 class="itemStyle">
            <v-chart
              theme="macarons"
              style="width: 95%; height: 95%; margin: 0 auto"
              :options="polar1"
            />
          </dv-border-box-12>
          <dv-border-box-12 class="itemStyle">
            <v-chart
              theme="macarons"
              style="width: 95%; height: 95%; margin: 0 auto"
              :options="polar2"
            />
          </dv-border-box-12>
          <dv-border-box-12 class="itemStyle">
            <v-chart
              theme="macarons"
              style="width: 95%; height: 95%; margin: 0 auto"
              :options="polar3"
            />
          </dv-border-box-12>
        </el-col>
        <!-- center -->
        <el-col :span="12">
          <el-row
            style="
              text-align: center;
              padding-top: 3vh;
              height: 14vh;
              box-sizing: border-box;
            "
          >
            <el-col :span="12">
              <p class="fontStyle">项目面积</p>
              <p class="fontColor">
                {{ projectDataV.ProjectArea }} <span>m3</span>
              </p>
            </el-col>
            <el-col :span="12">
              <p class="fontStyle">总体工期</p>
              <p class="fontColor">
                {{ projectDataV.ProjectTime }}
              </p>
            </el-col>
          </el-row>
          <dv-border-box-1 class="centerItemStyle">
            <v-chart
              theme="macarons"
              style="width: 95%; height: 95%; margin: 0 auto"
              :options="polar7"
            />
          </dv-border-box-1>
          <dv-border-box-1 class="centerItemStyle">
            <v-chart
              theme="macarons"
              style="width: 95%; height: 95%; margin: 0 auto"
              :options="polar8"
            />
          </dv-border-box-1>
        </el-col>
        <!-- right -->
        <el-col :span="6">
          <dv-border-box-12 class="itemStyle">
            <v-chart
              theme="macarons"
              style="width: 95%; height: 95%; margin: 0 auto"
              :options="polar4"
            />
          </dv-border-box-12>
          <dv-border-box-12 class="itemStyle">
            <v-chart
              theme="macarons"
              style="width: 95%; height: 95%; margin: 0 auto"
              :options="polar5"
            />
          </dv-border-box-12>
          <dv-border-box-12 class="itemStyle">
            <v-chart
              theme="macarons"
              style="width: 95%; height: 95%; margin: 0 auto"
              :options="polar6"
            /> </dv-border-box-12
        ></el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { ProjectDataV } from "@/setAxios";
export default {
  data() {
    let projectName = localStorage.XmName;
    let loadingShow = false;
    let polar1,
      polar2,
      polar3,
      polar4,
      polar5,
      polar6,
      polar7,
      polar8 = {};
    return {
      projectName,
      loadingShow,
      polar1,
      polar2,
      polar3,
      polar4,
      polar5,
      polar6,
      polar7,
      polar8,
      projectDataV: {},
    };
  },
  created() {
    this.ProjectDataV();
  },
  methods: {
    async ProjectDataV() {
      this.loadingShow = true;
      let params = {
        xid: localStorage.xid,
      };
      let res = await ProjectDataV({ params });
      this.projectDataV = res.Data;
      this.polar1 = {
        title: {
          text: "风险项分析",
          textStyle: {
            color: "#fff",
          },
          left: "center",
          top: "10",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        legend: {
          data: ["执行非风险项", "执行风险项", "审核非风险项", "审核风险项"],
          bottom: "0",
          textStyle: {
            color: "#fff",
          },
        },
        series: [
          {
            name: "数据来源",
            type: "pie",
            selectedMode: "single",
            radius: [0, "30%"],
            label: {
              show:false,
              position: "inner",
              fontSize: 14,
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: this.projectDataV.Fxxfx.shffxx, name: "审核非风险项" },
              { value: this.projectDataV.Fxxfx.shfxx, name: "审核风险项" },
            ],
          },
          {
            name: "数据来源",
            type: "pie",
            radius: ["45%", "60%"],
            data: [
              { value: this.projectDataV.Fxxfx.zxffxx, name: "执行非风险项" },
              { value: this.projectDataV.Fxxfx.zxfxx, name: "执行风险项" },
            ],
          },
        ],
      };
      this.polar2 = {
        title: {
          text: "计划执行状态监测",
          textStyle: {
            color: "#fff",
          },
          left: "center",
          top: "10",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        legend: {
          data: [
            "未启动正常",
            "未启动延期",
            "进行中正常",
            "进行中延期",
            "已完成正常",
            "已完成延期",
          ],
          bottom: "0",
          textStyle: {
            color: "#fff",
          },
          type: "scroll",
        },
        series: [
          {
            name: "数据来源",
            type: "pie",
            radius: ["45%", "60%"],
            data: [
              { value: this.projectDataV.Jhzxzt.wqdzc, name: "未启动正常" },
              { value: this.projectDataV.Jhzxzt.wqdyq, name: "未启动延期" },
              { value: this.projectDataV.Jhzxzt.jxzzc, name: "进行中正常" },
              { value: this.projectDataV.Jhzxzt.jxzyq, name: "进行中延期" },
              { value: this.projectDataV.Jhzxzt.ywczc, name: "已完成正常" },
              { value: this.projectDataV.Jhzxzt.ywcyq, name: "已完成延期" },
            ],
          },
        ],
      };
      this.polar3 = {
        title: {
          text: "计划审核状态监测",
          textStyle: {
            color: "#fff",
          },
          left: "center",
          top: "10",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        legend: {
          data: [
            "未审核正常",
            "未审核延期",
            "审核中正常",
            "审核中延期",
            "已审核正常",
            "已审核延期",
          ],
          bottom: "0",
          textStyle: {
            color: "#fff",
          },
          type: "scroll",
        },
        series: [
          {
            name: "数据来源",
            type: "pie",
            radius: ["45%", "60%"],
            data: [
              {
                value: this.projectDataV.Jhshzt
                  ? this.projectDataV.Jhshzt.wshzc
                  : 0,
                name: "未审核正常",
              },
              {
                value: this.projectDataV.Jhshzt
                  ? this.projectDataV.Jhshzt.wshyq
                  : 0,
                name: "未审核延期",
              },
              {
                value: this.projectDataV.Jhshzt
                  ? this.projectDataV.Jhshzt.shzzc
                  : 0,
                name: "审核中正常",
              },
              {
                value: this.projectDataV.Jhshzt
                  ? this.projectDataV.Jhshzt.shzyq
                  : 0,
                name: "审核中延期",
              },
              {
                value: this.projectDataV.Jhshzt
                  ? this.projectDataV.Jhshzt.yshzc
                  : 0,
                name: "已审核正常",
              },
              {
                value: this.projectDataV.Jhshzt
                  ? this.projectDataV.Jhshzt.yshyq
                  : 0,
                name: "已审核延期",
              },
            ],
          },
        ],
      };
      let _this = this;
      this.polar4 = {
        title: {
          text: "项目人员组成",
          textStyle: {
            color: "#fff",
          },
          left: "center",
          top: "10",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        legend: {
          data: (function () {
            let XmryName = [];
            _this.projectDataV.Xmryzc.forEach((ele) => {
              let str = ele.name;
              XmryName.push(str);
            });
            return XmryName;
          })(),
          bottom: "0",
          textStyle: {
            color: "#fff",
          },
          type: "scroll",
        },
        series: [
          {
            name: "数据来源",
            type: "pie",
            radius: ["45%", "60%"],
            data: (function () {
              let Xmry = [];
              _this.projectDataV.Xmryzc.forEach((element) => {
                let obj = {
                  value: element.zb,
                  name: element.name,
                };
                Xmry.push(obj);
              });
              return Xmry;
            })(),
          },
        ],
      };
      this.polar5 = {
        title: {
          text: "提资资料统计",
          textStyle: {
            color: "#fff",
          },
          left: "center",
          top: "10",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        legend: {
          data: (function () {
            let TzzlName = [];
            _this.projectDataV.Tzzl.forEach((ele) => {
              let str = ele.name;
              TzzlName.push(str);
            });
            return TzzlName;
          })(),
          bottom: "0",
          textStyle: {
            color: "#fff",
          },
          type: "scroll",
        },
        series: [
          {
            name: "数据来源",
            type: "pie",
            radius: ["45%", "60%"],
            data: (function () {
              let Tzzl = [];
              _this.projectDataV.Tzzl.forEach((element) => {
                let obj = {
                  value: element.zb,
                  name: element.name,
                };
                Tzzl.push(obj);
              });
              return Tzzl;
            })(),
          },
        ],
      };
      this.polar6 = {
        title: {
          text: "任务成果统计",
          textStyle: {
            color: "#fff",
          },
          left: "center",
          top: "10",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        legend: {
          data: (function () {
            let RwcgName = [];
            _this.projectDataV.Rwcg.forEach((ele) => {
              let str = ele.name;
              RwcgName.push(str);
            });
            return RwcgName;
          })(),
          bottom: "0",
          textStyle: {
            color: "#fff",
          },
          type: "scroll",
        },
        series: [
          {
            name: "数据来源",
            type: "pie",
            radius: ["45%", "60%"],
            data: (function () {
              let Rwcg = [];
              _this.projectDataV.Rwcg.forEach((element) => {
                let obj = {
                  value: element.zb,
                  name: element.name,
                };
                Rwcg.push(obj);
              });
              return Rwcg;
            })(),
          },
        ],
      };
      this.polar7 = {
        title: {
          text: "各项计划完成率",
          textStyle: {
            color: "#fff",
            fontWeight: "bold",
          },
          left: "center",
          top: "10",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: function (params) {
            let tip = `${params[0].name}<br>${(params[0].value * 100).toFixed(
              1
            )}%`;
            return tip;
          },
        },
        xAxis: {
          type: "category",
          axisLabel: {
            interval: 0,
            color: "#fff",
            rotate: -50,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#fff",
              opacity: 0.2,
            },
          },
          axisTick: {
            show: false,
          },
          data: (function () {
            let JhwclX = [];
            _this.projectDataV.Jhwcl.forEach((ele) => {
              let jhmStr = ele.jhm;
              JhwclX.push(jhmStr);
            });
            return JhwclX;
          })(),
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#fff",
            formatter: function (value, index) {
              return (value * 100).toFixed(1) + "%";
            },
          },
          splitArea: { show: false },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#fff",
              opacity: 0.2,
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#fff",
              opacity: 0.2,
            },
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            type: "bar",
            itemStyle: {
              normal: {
                color: "#00B7F7",
                label: {
                  show: true,
                  position: "top",
                  textStyle: {
                    color: "white",
                    fontSize: 16,
                  },
                  formatter: function (params) {
                    return (params.value * 100).toFixed(1) + "%";
                  },
                },
              },
            },
            data: (function () {
              let JhwclY = [];
              _this.projectDataV.Jhwcl.forEach((ele) => {
                let wclStr = ele.wcl;
                JhwclY.push(wclStr);
              });
              return JhwclY;
            })(),
          },
        ],
      };

      this.polar8 = {
        title: {
          text: "人员执行情况监测（完成率）",
          textStyle: {
            color: "#fff",
          },
          left: "center",
          top: "10",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: function (params) {
            let tip = `${params[0].name}<br>`;
            for (let i = 0; i < params.length; i++) {
              tip +=`${params[i].seriesName}:${(params[i].value * 100).toFixed(1)}%<br>`;
            }
            return tip;
          },
        },
        xAxis: {
          type: "category",
          axisLabel: {
            interval: 0,
            color: "#fff",
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#fff",
              opacity: 0.2,
            },
          },
          axisTick: {
            show: false,
          },
          // data:[1,2,3]
          data: (function () {
            let RyzxqkX = [];
            _this.projectDataV.Ryzxqk.forEach((ele) => {
              let nameStr = ele.name;
              RyzxqkX.push(nameStr);
            });
            return RyzxqkX;
          })(),
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#fff",
            formatter: function (value, index) {
              return (value * 100).toFixed(1) + "%";
            },
          },
          splitArea: { show: false },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#fff",
              opacity: 0.2,
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#fff",
              opacity: 0.2,
            },
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            name: "执行任务完成率",
            type: "bar",
            itemStyle: {
              normal: {
                color: "#842BDB",
                label: {
                  show: true,
                  position: "top",
                  textStyle: {
                    color: "white",
                    fontSize: 16,
                  },
                  formatter: function (params) {
                    return (params.value * 100).toFixed(1) + "%";
                  },
                },
              },
            },
            data: (function () {
              let zxrwwclY = [];
              _this.projectDataV.Ryzxqk.forEach((ele) => {
                let zxrwwclNum = ele.zxrwwcl;
                zxrwwclY.push(zxrwwclNum);
              });
              return zxrwwclY;
            })(),
          },
          {
            name: "审核任务完成率",
            type: "bar",
            itemStyle: {
              normal: {
                color: "#F3F506",
                label: {
                  show: true,
                  position: "top",
                  textStyle: {
                    color: "white",
                    fontSize: 16,
                  },
                },
              },
            },
            data: (function () {
              let shrwwclY = [];
              _this.projectDataV.Ryzxqk.forEach((ele) => {
                let shrwwclNum = ele.shrwwcl;
                shrwwclY.push(shrwwclNum);
              });
              return shrwwclY;
            })(),
          },
        ],
      };
      this.loadingShow = false;
    },
  },
};
</script>

<style lang = "less" scoped>
.projectDataV {
  width: 100vw;
  height: 100vh;
  background: url(../../assets/img/projectDataV.png);
  background-size: 100%;
  .top {
    font-size: 42px;
    text-align: center;
    color: #fff;
    width: 100%;
    height: 10vh;
    line-height: 10vh;
  }
  .content {
    width: 100%;
    height: 90vh;
  }
  .itemStyle {
    height: 30vh;
  }
  .centerItemStyle {
    height: 38vh;
  }
  .fontStyle {
    font-size: 32px;
    color: #fff;
  }
  .fontColor {
    font-size: 32px;
    color: #0ff;
    span {
      color: #c280ff;
    }
  }
}
</style>